// extracted by mini-css-extract-plugin
module.exports = {"noScrolling":"page_noScrolling__mzrMF","container":"page_container__TAX2z","statsContainer":"page_statsContainer__qt6ZD"};